{
  "banner.close": "Sulje",
  "jasenedut.allCategories": "Kaikki edut",
  "jasenedut.cityFilterAll": "Kaikki kaupungit",
  "jasenedut.cityFilterLabel": "Kaupunki",
  "jasenedut.demoDisclosure": "Esimerkkisisältöä: nämä edut ovat demoesimerkkejä, eivät oikeita kumppanietuja.",
  "jasenedut.empty": "Ei etuja saatavilla.",
  "jasenedut.heading": "Edut ja alennukset",
  "jasenedut.linkLabel": "Lue lisää täältä",
  "jasenedut.linkNewTabHint": "(avautuu uuteen välilehteen)",
  "jasenedut.showDetails": "Näytä lisätiedot",
  "login.disclaimer.demoIntent": "Tämä näkymä vain testaamista varten. Normaalisti tässä olisi vahva tunnistautuminen.",
  "login.heading": "Kirjaudu sisään",
  "analytics.consent.notice.accept": "Salli mittaaminen",
  "analytics.consent.notice.body": "Sallimalla käytön mittaamisen autat YTK:tä ymmärtämään, mitä Oma+:n toimintoja käytetään ja miten palvelu toimii. Näitä tietoja käytetään palvelun kehittämiseen. Ylläpidon raporteissa tiedot näkyvät yhteenvetoina, eivät nimelläsi tai jäsennumerollasi.\n\nMittauksessa käyttötietosi voidaan yhdistää eri käyntien ja laitteiden välillä. Mittaaminen on vapaaehtoista: voit käyttää Oma+:aa myös ilman sitä ja muuttaa valintaa milloin tahansa Omat tiedot -näkymässä.",
  "analytics.consent.notice.failed": "Valintaa ei tallennettu. Mittaaminen pysyy pois päältä.",
  "analytics.consent.notice.dismiss": "Sulje mittausvalinta",
  "analytics.consent.notice.heading": "Auta kehittämään Oma+:aa",
  "analytics.consent.notice.refuse": "En salli mittaamista",
  "analytics.consent.notice.retry": "Yritä uudelleen",
  "analytics.consent.notice.saving": "Tallennetaan…",
  "analytics.consent.notice.stale": "Valinta muuttui toisella laitteella. Tarkista nykyinen valinta ja valitse uudelleen.",
  "analytics.consent.profile.accepted": "Sallittu. Voit perua sivuston käytön mittaamisen milloin tahansa.",
  "analytics.consent.profile.currentChoice": "Nykyinen valinta",
  "analytics.consent.profile.disabled": "Mittaaminen ei ole käytössä.",
  "analytics.consent.profile.enable": "Salli mittaaminen",
  "analytics.consent.profile.heading": "Auta kehittämään Oma+:aa",
  "analytics.consent.profile.retryWithdraw": "Yritä perua suostumus uudelleen",
  "analytics.consent.profile.withdraw": "Peru mittaamisen salliminen",
  "analytics.consent.notice.unavailable": "Mittausvalintaa ei voitu tarkistaa. Mittaaminen pysyy pois päältä.",
  "messages.empty": "Ei viestejä",
  "messages.title": "Viestit",
  "myData.audit.count": "Sinuun liittyviä lokitapahtumia",
  "myData.audit.earliest": "Vanhin tapahtuma",
  "myData.audit.heading": "Tapahtumaloki",
  "myData.analytics.active": "Aktiivinen käyttö",
  "myData.analytics.active.missing": "Aktiivista käyttöä ei mitattu",
  "myData.analytics.attribution.unavailable": "Ei saatavilla",
  "myData.analytics.campaignMedium": "Kampanjan kanava",
  "myData.analytics.campaignName": "Kampanjan nimi",
  "myData.analytics.campaignSource": "Kampanjan lähde",
  "myData.analytics.device.desktop": "Tietokone",
  "myData.analytics.device.mobile": "Mobiililaite",
  "myData.analytics.device.tablet": "Tabletti",
  "myData.analytics.device.unknown": "Tuntematon laite",
  "myData.analytics.empty": "Sivuston käyttötietoja ei ole tallennettu.",
  "myData.analytics.entryDevice": "Aloituslaite",
  "myData.analytics.entryLanguage": "Aloituskieli",
  "myData.analytics.entrySource": "Aloituslähde",
  "myData.analytics.error.render": "Renderöintivirhe",
  "myData.analytics.error.resourceLoad": "Resurssin latausvirhe",
  "myData.analytics.error.routeLoad": "Näkymän latausvirhe",
  "myData.analytics.error.unhandled": "Käsittelemätön virhe",
  "myData.analytics.errors": "Virhemittaukset",
  "myData.analytics.errors.none": "Virhemittauksia ei kirjattu",
  "myData.analytics.heading": "Sivuston käyttötiedot",
  "myData.analytics.language.en": "Englanti",
  "myData.analytics.language.fi": "Suomi",
  "myData.analytics.language.sv": "Ruotsi",
  "myData.analytics.language.unknown": "Tuntematon kieli",
  "myData.analytics.load.document": "Asiakirjan lataus",
  "myData.analytics.load.route": "Näkymän lataus",
  "myData.analytics.loadingNext": "Ladataan seuraavaa sivua…",
  "myData.analytics.loads": "Latausmittaukset",
  "myData.analytics.loads.none": "Latausmittauksia ei kirjattu",
  "myData.analytics.nextPage": "Näytä seuraava sivu",
  "myData.analytics.occurredAt": "Ajankohta",
  "myData.analytics.page": "Sivu",
  "myData.analytics.pageError": "Seuraavan sivun lataaminen epäonnistui. Yritä uudelleen.",
  "myData.analytics.quality": "Mittauksen laatu",
  "myData.analytics.quality.measured": "Täydellinen mittaus",
  "myData.analytics.quality.partial": "Osittainen mittaus",
  "myData.analytics.quality.unavailable": "Mittaus ei ole saatavilla",
  "myData.analytics.referrerHost": "Viittaavan sivuston verkkotunnus",
  "myData.analytics.retry": "Yritä uudelleen",
  "myData.analytics.source.direct": "Suora siirtyminen",
  "myData.analytics.source.email": "Sähköposti",
  "myData.analytics.source.paid": "Maksettu mainonta",
  "myData.analytics.source.referral": "Viittaava sivusto",
  "myData.analytics.source.search": "Hakukone",
  "myData.analytics.source.social": "Sosiaalinen media",
  "myData.analytics.source.unknown": "Tuntematon lähde",
  "myData.analytics.unavailable": "Sivuston käyttötiedot eivät ole juuri nyt saatavilla.",
  "myData.successfulMemberMessages.category.jasenasiat": "Jäsenasiat",
  "myData.successfulMemberMessages.category.lakikaveri": "Lakikaveri",
  "myData.successfulMemberMessages.empty": "Onnistuneita lähetettyjä viestejä ei ole tallennettu.",
  "myData.successfulMemberMessages.heading": "Onnistuneet lähetetyt viestit",
  "myData.successfulMemberMessages.kind.initial": "Ensimmäinen yhteydenotto",
  "myData.successfulMemberMessages.kind.reply": "Vastaus",
  "myData.successfulMemberMessages.loadingNext": "Ladataan seuraavaa sivua…",
  "myData.successfulMemberMessages.messageKind": "Viestin tyyppi",
  "myData.successfulMemberMessages.nextPage": "Näytä seuraava sivu",
  "myData.successfulMemberMessages.occurredAt": "Ajankohta",
  "myData.successfulMemberMessages.pageError": "Seuraavan sivun lataaminen epäonnistui. Yritä uudelleen.",
  "myData.successfulMemberMessages.retry": "Yritä uudelleen",
  "myData.successfulMemberMessages.serviceCategory": "Palveluluokka",
  "myData.successfulMemberMessages.unavailable": "Onnistuneiden lähetettyjen viestien tiedot eivät ole juuri nyt saatavilla.",
  "myData.contactVerification.heading": "Yhteystietojen varmistus",
  "myData.contactVerification.lastVerified": "Viimeksi vahvistettu",
  "myData.contactVerification.never": "Et ole vielä vahvistanut yhteystietojasi.",
  "myData.languageSetting.heading": "Kielivalinta",
  "myData.languageSetting.chosen": "Valittu kieli",
  "myData.languageSetting.never": "Et ole valinnut kieltä. Sovellus näytetään suomeksi.",
  "myData.languageSetting.language.en": "Englanti",
  "myData.languageSetting.language.fi": "Suomi",
  "myData.languageSetting.language.sv": "Ruotsi",
  "myData.feedback.empty": "Et ole antanut palautetta.",
  "myData.feedback.heading": "Antamasi palaute",
  "myData.feedback.rating": "Arvosana",
  "myData.intro": "Tällä sivulla näet kootusti tiedot, joita sovellus säilyttää sinusta. Kunkin tietoryhmän kohdalla kerrotaan, hallinnoidaanko tietoa tässä sovelluksessa vai toisessa palvelussa.",
  "myData.legacy.heading": "Muissa palveluissa hallinnoidut tiedot",
  "myData.legacy.messaging.note": "Viestisi YTK:lle hallinnoidaan OmaYTK-palvelussa. Sovellus näyttää ne sieltä eikä tallenna niistä kopiota.",
  "myData.ownership.app": "Hallinnoidaan tässä sovelluksessa",
  "myData.ownership.legacy": "Hallinnoidaan toisessa palvelussa",
  "myData.profile.email": "Sähköposti",
  "myData.profile.heading": "Profiili",
  "myData.profile.memberNumber": "Jäsennumero",
  "myData.profile.name": "Nimi",
  "profile.admin.heading": "Ylläpitäjä",
  "profile.back": "Takaisin",
  "profile.certificate.download": "Lataa jäsentodistus",
  "profile.certificate.downloadError": "Jäsentodistuksen lataaminen ei onnistunut. Yritä uudelleen.",
  "profile.certificate.downloaded": "Jäsentodistus ladattu.",
  "profile.certificate.downloading": "Luodaan jäsentodistusta…",
  "profile.certificate.feePaid": "Maksettu",
  "profile.certificate.feeUnpaid": "Maksamatta",
  "profile.certificate.feeStatus": "Jäsenmaksun tilanne",
  "profile.certificate.heading": "Jäsentodistus",
  "profile.certificate.issuedAt": "Päivämäärä",
  "profile.certificate.memberName": "Nimi",
  "profile.certificate.memberNumber": "Jäsennumero",
  "profile.certificate.startDate": "Jäsenyyden alkupäivä",
  "profile.certificate.contactService": "Jäsentodistusta ei voi luoda, koska jäsentiedoissasi on puute. Ota yhteyttä jäsenpalveluun.",
  "profile.certificate.unavailable": "Jäsentodistus ei ole juuri nyt saatavilla. Yritä myöhemmin uudelleen.",
  "profile.contact.email": "Sähköposti",
  "profile.contact.heading": "Yhteystiedot",
  "profile.contact.phone": "Puhelinnumero",
  "profile.contact.syncNotice": "Yhteystietosi päivittyvät YTK Työelämän ja YTK Työttömyyskassan välillä. Voit halutessasi hallinnoida suostumusta yhteystietojen päivittymiseen YTK Työttömyyskassan",
  "profile.contact.syncNoticeLink": "OmaYTK -palvelussa",
  "profile.fee.account": "Tilinumero",
  "profile.fee.amount": "Summa",
  "profile.fee.bank": "Pankki",
  "profile.fee.billingMethod": "Laskutustapa",
  "profile.fee.copyAccount": "Kopioi tilinumero",
  "profile.fee.copyReference": "Kopioi viitenumero",
  "profile.fee.dueDate": "Eräpäivä",
  "profile.fee.empty": "Ei laskuja.",
  "profile.fee.eInvoice.guidance": "Saat jäsenmaksulaskusi tällä hetkellä paperilaskuna. Voit siirtyä e-laskuun, jolloin laskut tulevat jatkossa suoraan verkkopankkiisi.",
  "profile.fee.eInvoice.methodPaper": "Paperilasku",
  "profile.fee.eInvoice.methodEInvoice": "E-lasku",
  "profile.fee.eInvoice.methodUnknown": "Laskutustapaasi ei juuri nyt pystytty selvittämään.",
  "profile.fee.eInvoice.pending": "E-laskuehdotus tilattu {date}\n\nLähetimme ehdotuksen verkkopankkiisi. Käy hyväksymässä se verkkopankissasi, niin laskutustapa muuttuu e-laskuksi. Voit tilata uuden ehdotuksen aikaisintaan {again}.",
  "profile.fee.eInvoice.unavailable": "Laskutustietoja ei juuri nyt saada haettua. Yritä hetken kuluttua uudelleen.",
  "profile.fee.eInvoice.submitting": "Lähetetään e-laskuehdotusta…",
  "profile.fee.eInvoice.unconfirmed": "Emme pystyneet vahvistamaan e-laskuehdotuksen tilausta. Ehdotus on todennäköisesti silti matkalla verkkopankkiisi. Tarkista verkkopankkisi muutaman arkipäivän kuluttua ennen kuin tilaat uuden ehdotuksen.",
  "profile.fee.eInvoice.errorAlreadyRequested": "Sinulla on jo e-laskuehdotus vireillä. Käy hyväksymässä se verkkopankissasi.",
  "profile.fee.eInvoice.errorUnsupportedBank": "Valitsemaasi pankkia ei voi juuri nyt käyttää e-laskuehdotukseen. Valitse toinen pankki tai yritä myöhemmin uudelleen.",
  "profile.fee.eInvoice.errorRetryConflict": "Edellinen tilauksesi on vielä käsittelyssä. Yritä hetken kuluttua uudelleen.",
  "profile.fee.eInvoice.errorRefused": "E-laskuehdotusta ei voitu tehdä. Ota yhteyttä jäsenpalveluun.",
  "profile.fee.eInvoice.errorUnavailable": "E-laskuehdotuksen tilaus ei juuri nyt onnistunut. Yritä hetken kuluttua uudelleen.",
  "profile.fee.eInvoice.cancel": "Peruuta",
  "profile.fee.eInvoice.confirmation": "E-laskuehdotus lähetetty. Ehdotus saapuu verkkopankkiisi 1–3 arkipäivän kuluessa. Muista käydä hyväksymässä se verkkopankissasi — vasta hyväksynnän jälkeen laskutustapa muuttuu e-laskuksi.",
  "profile.fee.eInvoice.description": "Kun tilaat e-laskuehdotuksen, lähetämme verkkopankkiisi ehdotuksen jäsenmaksun e-laskusta. Ehdotus näkyy verkkopankissasi 1–3 arkipäivän kuluessa pankista riippuen.\n\nHyväksyt ehdotuksen itse verkkopankissasi. Vasta hyväksynnän jälkeen laskutustapa muuttuu e-laskuksi, ja saat jäsenmaksulaskut jatkossa suoraan verkkopankkiisi.\n\nValitse pankkisi ja paina Tilaa.",
  "profile.fee.eInvoice.request": "Tilaa e-laskuehdotus",
  "profile.fee.eInvoice.placeholder": "Valitse pankki",
  "profile.fee.eInvoice.sessionExpired": "Istuntosi on vanhentunut. Kirjaudu uudelleen sisään ja tilaa e-laskuehdotus sen jälkeen.",
  "profile.fee.eInvoice.selectBank": "Pankki",
  "profile.fee.eInvoice.submit": "Tilaa",
  "profile.fee.heading": "Jäsenmaksu",
  "profile.fee.invoiceDate": "Laskun päiväys",
  "profile.fee.invoiceNumber": "Laskun numero",
  "profile.fee.payCta": "Siirry maksamaan",
  "profile.fee.payNotPayable": "Tätä laskua ei voi maksaa palvelussa juuri nyt.",
  "profile.fee.payRetry": "Maksun aloittaminen ei onnistunut. Yritä uudelleen.",
  "profile.fee.payUnavailable": "Maksaminen ei ole juuri nyt käytettävissä.",
  "profile.fee.paymentHistory": "Aiemmat laskut",
  "payment.return.backToFee": "Palaa jäsenmaksuun",
  "payment.return.notCompleted.body": "Maksua ei suoritettu. Voit palata jäsenmaksuun ja yrittää uudelleen.",
  "payment.return.notCompleted.heading": "Maksua ei suoritettu",
  "payment.return.pending.body": "Maksusi on vastaanotettu. Maksun vahvistus on vielä kesken – tilanne päivittyy jäsenmaksunäkymään.",
  "payment.return.pending.heading": "Maksu vastaanotettu",
  "profile.fee.reference": "Viitenumero",
  "profile.fee.status": "Tila",
  "profile.fee.statusPaid": "Maksettu",
  "profile.fee.statusPaidPaytrail": "Maksettu (Paytrail)",
  "profile.fee.statusUnavailable": "Maksun tila ei saatavilla",
  "profile.fee.statusUnpaid": "Ei maksettu",
  "profile.fee.unavailable": "Jäsenmaksutiedot eivät ole juuri nyt saatavilla. Yritä myöhemmin uudelleen.",
  "profile.hub.certificate": "Jäsentodistus",
  "profile.hub.contact": "Omat yhteystiedot",
  "profile.hub.fee": "Jäsenmaksu",
  "profile.hub.myData": "Tallennetut tiedot",
  "profile.myData.unavailable": "Tallennetut tiedot eivät ole juuri nyt saatavilla. Yritä myöhemmin uudelleen.",
  "profile.memberNumber.copyButton": "Kopioi jäsennumero",
  "profile.memberNumber.copied": "Jäsennumero kopioitu",
  "profile.memberNumber.label": "Jäsennumero",
  "profile.membershipSummary": "{tier} {date} alkaen",
  "profile.membershipUnavailable": "Jäsenyystiedot eivät ole juuri nyt saatavilla.",
  "profile.title": "Omat tiedot",
  "profile.unavailable": "Profiilitiedot eivät ole juuri nyt saatavilla. Yritä myöhemmin uudelleen.",
  "profile.verify.cancel": "Peruuta",
  "profile.verify.confirm": "Tiedot ovat ajan tasalla",
  "profile.verify.emailSuggestions.label": "Sähköpostiehdotukset",
  "profile.verify.error.city": "Anna paikkakunta.",
  "profile.verify.error.email": "Anna kelvollinen sähköpostiosoite.",
  "profile.verify.error.phone": "Anna puhelinnumero.",
  "profile.verify.error.postalCode": "Anna viisinumeroinen postinumero.",
  "profile.verify.error.street": "Anna katuosoite.",
  "profile.verify.field.city": "Paikkakunta",
  "profile.verify.field.email": "Sähköposti",
  "profile.verify.field.phone": "Puhelinnumero",
  "profile.verify.field.postalCode": "Postinumero",
  "profile.verify.field.street": "Katuosoite",
  "profile.verify.intro": "Tarkista, että yhteystietosi ovat ajan tasalla.",
  "profile.verify.save": "Tallenna",
  "profile.verify.saveError.validation": "Tarkista antamasi tiedot ja yritä uudelleen.",
  "profile.verify.saveError.conflict": "Tietojasi ehdittiin muuttaa. Tarkista tiedot ja yritä uudelleen.",
  "profile.verify.saveError.unavailable": "Tallennus ei juuri nyt onnistunut. Yritä hetken kuluttua uudelleen.",
  "profile.verify.saveError.notFound": "Jäsentietojasi ei löytynyt. Ota yhteyttä asiakaspalveluun.",
  "profile.verify.saveSuccess": "Tiedot tallennettu.",
  "profile.verify.startEdit": "Päivitä tietoja",
  "profile.verify.title": "Tarkista yhteystietosi"
}
